import lscache from "lscache";
import { SESSION_STORAGE_KEY_PREFIX } from "@/hooks/useDataCache";

export enum CACHE_KEYS {
  DIRECTORY_CONTACTS = "DIRECTORY_CONTACTS",
}

//Call this when changes are made to the data
export function ClearCache(key: CACHE_KEYS) {
  lscache.remove(key);
}

//Call this on logout
export function ClearAllCache() {
  lscache.flush();
  Object.keys(window.sessionStorage).forEach((key) => {
    if (key.startsWith(SESSION_STORAGE_KEY_PREFIX)) {
      window.sessionStorage.removeItem(key);
    }
  });
}
